import { useRemovePresetGroup } from '@restDataAccess/camera/cameraControlApi.dataHooks.ts';
import { PresetGroupInfo } from '@scaleaq/sitecontrol-lib';
import { useTranslation } from 'react-i18next';

import { ConfirmDeleteDialog, useFeedbackAlert } from '@/components';
import { ModalControllerType } from '@/types.ts';

export const RemovePresetGroupConfirmModal = ({
  modalController,
  onSaved,
  presetGroup,
}: {
  modalController: ModalControllerType;
  onSaved: (saved: { name: string; operation: 'deleted' }) => void;
  presetGroup: PresetGroupInfo;
}) => {
  const { t } = useTranslation();
  const { feedback, setFeedback, clearFeedback } = useFeedbackAlert();
  const { mutate, isPending } = useRemovePresetGroup();

  const handleClose = () => {
    modalController.onClose();
    clearFeedback();
  };

  const handleConfirmDelete = () => {
    mutate(
      { id: presetGroup.id },
      {
        onSuccess: () => {
          handleClose();
          onSaved({ name: presetGroup.name, operation: 'deleted' });
        },
        onError: error => {
          const message = error instanceof Error ? error.message : '';
          setFeedback({
            text: t('snackbar.error.delete', { name: presetGroup.name, message }),
            variant: 'alarm',
          });
        },
      }
    );
  };

  return (
    <ConfirmDeleteDialog
      open={modalController.open}
      onClose={handleClose}
      onConfirm={handleConfirmDelete}
      itemName={presetGroup.name}
      loading={isPending}
      feedback={feedback}
      onFeedbackDismiss={clearFeedback}
    />
  );
};
